import { apiClient } from "@/modules/shared/utils/apiClient";

import { CreateCoachMatchingSessionRequest } from "../types/CreateCoachMatchingSessionRequest";
import { CreateCoachMatchingSessionResponse } from "../types/CreateCoachMatchingSessionResponse";

export const createCoachMatchingSessionRequest = (
  data: CreateCoachMatchingSessionRequest,
) =>
  apiClient.post<CreateCoachMatchingSessionResponse>(
    "/coach-matching/sessions",
    data,
  );
